function PlaceholderPage({ title }) {
  return (
    <div className="pageCenter">
      <h1 className="pageCenter__title">{title}</h1>
    </div>
  );
}

export default PlaceholderPage;
